var sticky_title_bar = require( './sticky-title-bar' ),
	utils = require( './utils' );

var filter_title_bar = ( function( $ ) {

	var $title_bar,
		$toggle_links,
		did_scroll,
		filter_bar_height,
		filter_term,
		is_filtered_by_bar = false,
		$filter_bar_title_responsive;

	var _init = function() {
		$title_bar = $( '.filter-title-bar' );
		$toggle_links = $title_bar.find( '.toggle-link' );
		filter_bar_height = $title_bar.outerHeight();

		$filter_bar_title_responsive = $( "#filter-bar-title-responsive" );

		$( window ).scroll( function() {
			did_scroll = true;
		} );

		if ( $( '.filtered-by-bar' ).length > 0 ) {
			is_filtered_by_bar = true;
		}

		_setup_filter_toggle();

		_setup_responsive_dropdown();
	};

	var _setup_filter_toggle = function() {

		$toggle_links.on( 'click', function( e ) {
			e.preventDefault();

			var $this = $( this );
			if ( $( window ).width() >= 1200 ) {
				_filter_toggle_wide_screen( $this );
			} else {
				_filter_toggle_responsive( $this );
			}

		} );
	};

	var _filter_toggle_wide_screen = function( $this ) {

		filter_term = $this.attr( 'data-term' );

		var $filter_toggle = $this.closest( '.toggle-filters' );
		var opening;
		var opening_different;

		if ( $filter_toggle.closest( '.filter-toggle' ).hasClass( 'in-use' ) ) {
			return;
		}

		opening = $filter_toggle.closest( '.filter-toggle' ).toggleClass( 'open' ).addClass( 'in-use' ).hasClass( 'open' );

		if ( opening ) {
			_on_open_filter( $this, filter_term );
		}
		opening_different = !opening && ( $( '#filter-select-' + filter_term ).next().hasClass( 'hidden' ) );

		//wide screen
		$filter_toggle.siblings( '.filter-toggle-panel' ).slideToggle( {
			done: function() {
				if ( !opening ) {
					$( '.filter-search-input' ).not( '.responsive' ).next().addClass( 'hidden' );
					$( '.dropdown-applied-filters' ).addClass( 'hidden' );
					$( '.dropdown-applied-filters' ).parent().addClass( 'hidden' );
					$( '.popular-terms' ).addClass( 'hidden' );
					$( '.toggle-link' ).children( '.icon' ).removeClass( 'arrow-active' );

					if ( opening_different ) {
						_on_open_filter( $this, filter_term );
						$filter_toggle.closest( '.filter-toggle' ).toggleClass( 'open' );
						$filter_toggle.siblings( '.filter-toggle-panel' ).slideToggle(
							{
								done: function() {
									$filter_toggle.closest( '.filter-toggle' ).removeClass( 'in-use' );
								}
							}
						);
					} else {
						$filter_toggle.closest( '.filter-toggle' ).removeClass( 'in-use' );
					}
				} else {
					$filter_toggle.closest( '.filter-toggle' ).removeClass( 'in-use' );
				}
			}
		} );
	};

	var _filter_toggle_responsive = function( $this ) {
		filter_term = $this.attr( 'data-term' );

		$( '.filter-toggle-panel-responsive' ).each( function( index, element ) {
			if ( $( element ).data( 'term' ) === filter_term ) {

				var $icon = $this.find( '.icon' );
				var opening = !$icon.hasClass( 'arrow-active' );

				if ( opening ) {
					$icon.addClass( 'arrow-active' );
				}

				$( element ).slideToggle( {
					done: function() {
						if ( !opening ) {
							$icon.removeClass( 'arrow-active' );
						}
					}
				} );
			}
		} );
	};

	var _on_open_filter = function( $this, filter_term ) {

		//only make applied terms hidden if there are some, otherwise show popular terms
		var $applied_filters = $( '.applied-filters-' + filter_term );
		if ( $applied_filters.children().length > 0 ) {
			$applied_filters.removeClass( 'hidden' );
			$applied_filters.parent().removeClass( 'hidden' );
		} else {
			$( '.popular-terms' ).removeClass( 'hidden' );
		}

		$( '#filter-select-' + filter_term ).next().removeClass( 'hidden' );
		$this.children( '.icon' ).addClass( 'arrow-active' );
	};

	var _setup_responsive_dropdown = function() {

		$filter_bar_title_responsive.on( 'click', function() {

			if ( $( window ).width() < 1200 ) {

				var $to_slide = $filter_bar_title_responsive.siblings( '.toggle-links' );
				$filter_bar_title_responsive.children( '.icon' ).toggleClass( 'arrow-active' );

				$to_slide.slideToggle();
			}

		} );

	};

	if ( $( '.filter-title-bar' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = filter_title_bar;